import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { cloneDeep, isEqual } from "lodash";
import { persistReducer, PERSIST, PURGE, REHYDRATE } from "redux-persist";
import storage from "redux-persist/lib/storage";

import axiosUtils from "@plannel/utils/axios-bigint";
import historyReducer from "@plannel/redux/modules/HistoryState";
import viewReducer from "@plannel/redux/modules/viewStates";
import tabReducer from "@plannel/redux/modules/TabState";
import agentChatReducer from "@plannel/redux/modules/AgentChatState";
import navHistoryReducer from "@plannel/redux/modules/NavHistoryState";
import workflowPanelReducer from "@plannel/redux/modules/WorkflowPanelState";

const persistConfig = {
  key: "root",
  storage
};
const customSerializableMiddleware = (_store) => next => action => {
  const payload = cloneDeep(action.payload);

  if (typeof payload === "string") {
    return next(action);
  }

  for (const key in payload) {
    if (key !== "viewName") {
      if (!(isEqual(action.type, REHYDRATE) && typeof payload[key] === 'string')) {
        payload[key] = axiosUtils.jsonbigStringfy(payload[key]);
      }
    }
  }

  action.payload = payload;

  return next(action);
}

const rootReducer = combineReducers({
  historyState: historyReducer,
  viewStates: viewReducer,
  tabState: persistReducer(persistConfig, tabReducer),
  agentChatState: agentChatReducer,
  navHistoryState: navHistoryReducer,
  workflowPanelState: workflowPanelReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: { ignoredActions: [PERSIST, PURGE] } })
    .concat(customSerializableMiddleware)
});